import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./PromoBanner.css";

export default function PromoBanner({
  imageUrl = "/images/downloadsssssss.jpg",
  to = "/haqqimizda",
}) {
  const { t } = useTranslation();

  return (
    <section
      className="promoBanner"
      style={{ backgroundImage: `url('${imageUrl}')` }}
    >
      <div className="promoOverlay">
        <div className="promoContent">
          <h2>{t("promo_title")}</h2>
          <p>{t("promo_text")}</p>
          <Link to={to} className="promoBtn">
            {t("promo_btn")}
          </Link>
        </div>
      </div>
    </section>
  );
}
